import { handleAuthResponse } from "../auth";

// Public endpoint — no auth — used by the About page to show current
// committee chairs & co-chairs sourced from the Groups collection.
export const listLeadership = () => {
    return fetch(`${process.env.REACT_APP_API_URL}/groups/leadership`, {
        method: "GET"
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

// with pagination
export const list = page => {
    return fetch(`${process.env.REACT_APP_API_URL}/group/?page=${page}`, {
        method: "GET",
        credentials: 'include'
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

export const loadSurveyData = (token) => {
    return fetch(`${process.env.REACT_APP_API_URL}/surveyresults`, {
        method: "GET",
        credentials: 'include',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        }
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

export const sendMessage = async (message) => {
    return fetch(`${process.env.REACT_APP_API_URL}/mail/sendServerEmail`, {
        method: "POST",
        credentials: 'include',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(message)
    })
        .then(handleAuthResponse)
        .catch(err => {
            console.error("sendMessage API error:", err);
            return { error: err.message || "Network error occurred" };
        });
};

export const chatbotapi = question => {

    return fetch(`${process.env.REACT_APP_API_URL}/qna/searchAnswers`, {
        method: "POST",
        credentials: 'include',
        'headers': {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ "question": question })
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
}

//Get all groups
export const listGroups = (token) => {
    return fetch(`${process.env.REACT_APP_API_URL}/groups`, {
        method: "GET",
        credentials: 'include',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        }
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

// // Check user access
// export const groupAccessforUser = (token, userId) => {
//     return fetch(`${process.env.REACT_APP_API_URL}/group/member/${userId}`, {
//         method: "GET",
//         credentials: 'include',
//         headers: {
//             Accept: "application/json",
//             "Content-Type": "application/json",
//         }
//     })
//         .then(response => {
//             return response.json();
//         })
//         .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
// };

export const singleGroup = groupId => {
    return fetch(`${process.env.REACT_APP_API_URL}/group/${groupId}`, {
        method: "GET",
        credentials: 'include'
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

export const groupDetails = (groupId) => {
    return fetch(`${process.env.REACT_APP_API_URL}/groupdetails`, {
        method: "POST",
        credentials: 'include',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ groupId })
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
}


// Edit committee details (name/description). Backend authorizes via isGroupAdmin,
// so only the chair, co-chair, or a global admin can actually persist changes.
export const updateGroup = (groupId, userId, group) => {
    return fetch(`${process.env.REACT_APP_API_URL}/group/${groupId}/${userId}`, {
        method: "PUT",
        credentials: 'include',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(group)
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

export const removeUserFromGroup = (token, groupId, userId) => {
    //console.log(groupId, userId)
    return fetch(`${process.env.REACT_APP_API_URL}/group/removeMember`, {
        method: "PUT",
        credentials: 'include',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ groupId, userId })
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};



export const addUsertoGroup = (token, groupId, userId) => {
    //console.log(groupId, userId)
    return fetch(`${process.env.REACT_APP_API_URL}/group/addMember`, {
        method: "PUT",
        credentials: 'include',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ groupId, userId })
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

export const listPresentationsByGroup = (groupId, token, year) => {
    return fetch(`${process.env.REACT_APP_API_URL}/presentationsbyGroup/${groupId}/${year}`, {
        method: "GET",
        credentials: 'include',
        mode: 'cors',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        }
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

